module.exports = __webpack_public_path__ + "static/media/consent_video.deb17f38.mp3";